import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../hooks/hooks';
import { resetUpdateScientificAreaData } from '../../redux/slices/school/scientificArea';
import { RootState } from '../../redux/store';
import { routes } from '../../routes';
import { updateScientificArea } from '../../services/school/scientificArea/updateScientificArea';
import { ScientificAreaType } from '../../types/ScientificAreas';
import { UpdateScientificAreaFormValidation } from './UpdateScientificAreaFormValidation';
import { useGetKnowledgeDomainsQuery } from '../../hooks/useGetKnowledgeDomainsQuery';
import { useGetKnowledgeSubDomainsQuery } from '../../hooks/useGetKnowledgeSubDomainsQuery';
import { isEmpty } from 'lodash';
import SelectComponent from '../../components/inputs/Select/SelectComponent';

export default function UpdateScientificArea() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mutation = useMutation({ mutationFn: updateScientificArea, mutationKey: "updateScientificArea" })
  const updateScientificAreaFormData = useSelector((state: RootState) => state.scientificArea);
  const queryClient = useQueryClient();

  const { control, handleSubmit, setValue, formState: { errors }, reset, getValues,resetField } = useForm<ScientificAreaType>({
    resolver: yupResolver(UpdateScientificAreaFormValidation),
    defaultValues: updateScientificAreaFormData,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  })

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success('Área criada atualizada!');
        queryClient.invalidateQueries('scientificArea-pagination');
        navigate(routes.scientificAreas);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
   const { data: domains, isLoading: isLoadingDomains, isError: errorDomains } = useGetKnowledgeDomainsQuery({ PageNumber: 1, PageSize: 400 });
    const { data: subDomains, isLoading: isLoadingSubDomains, isError: errorSubDomains, refetch: refreshSubDomains } = useGetKnowledgeSubDomainsQuery(
      { PageNumber: 1, PageSize: 400, DomainId: getValues('idKnowledgeDomain') },
      { enabled: !!getValues('idKnowledgeDomain') }
    );
      const handleKnowledgeDomainChange = (id: string) => {
        setValue('idKnowledgeDomain', id);
        if(isEmpty(id)){
          resetField('idKnowledgeSubDomain')
          return;
        }
        refreshSubDomains();
      };
  const handleBack = (e: any) => {
    dispatch(resetUpdateScientificAreaData());
    navigate(routes.scientificAreas);
  }

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label='Descrição' control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <Flex gap='4'>
            <SelectComponent
              name="idKnowledgeDomain"
              label="Domínio de Conhecimento"
              control={control}
              errors={errors}
              style={{ width: '100%' }}
              options={domains?.items.map(domain => ({
                value: domain.id ?? "",
                label: domain.description ?? ""
              }))}
              itemsLoading={isLoadingDomains}
              itemsError={errorDomains}
              onSelect={handleKnowledgeDomainChange}

            />
            <SelectComponent
              name="idKnowledgeSubDomain"
              label="SubDomínio de Conhecimento"
              control={control}
              errors={errors}
              style={{ width: '100%' }}
              options={subDomains?.items.map(domain => ({
                value: domain.id ?? "",
                label: domain.description ?? ""
              }))}
              itemsLoading={isLoadingSubDomains}
              itemsError={errorSubDomains}
            />
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}